/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1FeedbackFeedbackidClassStudents202,
  PostApiV1FeedbackFeedbackidClassStudents400,
  PostApiV1FeedbackFeedbackidClassStudents401,
  PostApiV1FeedbackFeedbackidClassStudents404,
  PostApiV1FeedbackFeedbackidClassStudents500,
  PostApiV1FeedbackFeedbackidClassStudentsMutationRequest,
  PostApiV1FeedbackFeedbackidClassStudentsMutationResponse,
  PostApiV1FeedbackFeedbackidClassStudentsPathParams,
} from "../../types/feedbackTurmasController/PostApiV1FeedbackFeedbackidClassStudents.ts";
import { addFeedbackClassStudentsRequestViewModelSchema } from "../addFeedbackClassStudentsRequestViewModelSchema.ts";

export const postApiV1FeedbackFeedbackidClassStudentsPathParamsSchema =
  z.object({
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1FeedbackFeedbackidClassStudents202Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudents202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1FeedbackFeedbackidClassStudents400Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudents400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1FeedbackFeedbackidClassStudents401Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1FeedbackFeedbackidClassStudents404Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudents404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1FeedbackFeedbackidClassStudents500Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudents500>;

export const postApiV1FeedbackFeedbackidClassStudentsMutationRequestSchema =
  z.lazy(
    () => addFeedbackClassStudentsRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudentsMutationRequest>;

export const postApiV1FeedbackFeedbackidClassStudentsMutationResponseSchema =
  z.lazy(
    () => postApiV1FeedbackFeedbackidClassStudents202Schema,
  ) as unknown as ToZod<PostApiV1FeedbackFeedbackidClassStudentsMutationResponse>;
